import { Platform, StyleSheet } from 'react-native';
import type { WcColors } from './matchPickStats.helper';

export function getMatchPickStatsViewStyles(C: WcColors) {
  return StyleSheet.create({
    header: {
      paddingHorizontal: 16,
      paddingTop: 12,
      paddingBottom: 14,
      borderBottomWidth: StyleSheet.hairlineWidth,
      borderBottomColor: C.line,
      overflow: 'hidden',
    },
    topRow: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginBottom: 14,
    },
    backBtn: {
      width: 34,
      height: 34,
      borderRadius: 10,
      backgroundColor: C.panelHi,
      borderWidth: 1,
      borderColor: C.line,
      alignItems: 'center',
      justifyContent: 'center',
    },
    backBtnPressed: { opacity: 0.7 },
    headerCenter: {
      flex: 1,
      alignItems: 'center',
      paddingHorizontal: 8,
    },
    headerDateLabel: {
      fontSize: 11,
      color: C.inkDim,
      fontWeight: '600',
      letterSpacing: 0.3,
    },
    spacer: {
      width: 34,
    },
    teamsGrid: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: 10,
    },
    teamCol: {
      flex: 1,
      alignItems: 'center',
      gap: 6,
    },
    teamName: {
      fontSize: 14,
      fontWeight: '800',
      color: C.ink,
      textAlign: 'center',
    },
    vsCol: {
      alignItems: 'center',
      gap: 6,
      paddingHorizontal: 6,
    },
    statusChip: {
      borderRadius: 99,
      paddingHorizontal: 10,
      paddingVertical: 4,
      flexDirection: 'row',
      alignItems: 'center',
      gap: 4,
    },
    statusChipLive: {
      backgroundColor: C.red + '21',
      borderWidth: 1,
      borderColor: C.red + '55',
    },
    statusChipDefault: {
      backgroundColor: C.purple + '1F',
      borderWidth: 1,
      borderColor: C.purple + '3D',
    },
    liveDot: {
      width: 6,
      height: 6,
      borderRadius: 3,
      backgroundColor: C.red,
    },
    statusChipText: {
      fontSize: 9,
      fontWeight: '800',
      letterSpacing: 0.8,
      textTransform: 'uppercase',
    },
    statusChipTextLive: { color: C.red },
    statusChipTextDefault: { color: C.purpleHi },
    scoreOrVsText: {
      fontSize: 22,
      fontWeight: '800',
      letterSpacing: -0.5,
    },
    scoreOrVsTextDim: { color: C.inkDim },
    scoreOrVsTextBright: { color: C.ink },
    memberPicksWrap: {
      marginTop: 18,
    },
    memberPicksTitleRow: {
      marginHorizontal: 16,
    },
    pickFooterWrap: {
      position: 'absolute',
      left: 0,
      right: 0,
      bottom: 0,
      paddingHorizontal: 16,
      paddingBottom: 14,
      paddingTop: 20,
    },
    pickFooterWrapPointerEvents: {
      pointerEvents: 'box-none' as never,
    },
    pickFooterCard: {
      minHeight: 66,
      borderRadius: 16,
      paddingVertical: 10,
      paddingLeft: 14,
      paddingRight: 12,
      flexDirection: 'row',
      alignItems: 'center',
      gap: 12,
      backgroundColor: C.purpleDeep,
      ...(Platform.OS === 'web' && {
        maxWidth: 520,
        width: '100%' as never,
        alignSelf: 'center' as const,
        boxShadow: `0 16px 34px ${C.purpleDeep}66` as never,
      }),
    },
    pickFooterCopy: {
      flex: 1,
      minWidth: 0,
    },
    pickFooterEyebrow: {
      fontSize: 10,
      fontWeight: '900',
      color: C.textOnPrimary + 'CC',
      letterSpacing: 0.9,
      textTransform: 'uppercase',
      marginBottom: 2,
    },
    pickFooterText: {
      fontSize: 18,
      fontWeight: '900',
      color: C.textOnPrimary,
      letterSpacing: -0.6,
    },
    pickFooterButton: {
      minHeight: 42,
      paddingHorizontal: 18,
      borderRadius: 999,
      backgroundColor: C.textOnPrimary,
      alignItems: 'center',
      justifyContent: 'center',
    },
    pickFooterButtonPressed: {
      opacity: 0.82,
    },
    pickFooterButtonDisabled: {
      backgroundColor: C.textOnPrimary + '26',
    },
    pickFooterButtonText: {
      fontSize: 12,
      fontWeight: '900',
      color: C.purpleDeep,
      letterSpacing: 0.6,
      textTransform: 'uppercase',
    },
    pickFooterButtonTextDisabled: {
      color: C.textOnPrimary + 'AA',
    },
  });
}
